<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3" id="names"><a id="page_xi"></a>NAMES AND RELATIONSHIPS</h3>
<p class="names">ABDOUL AZIZ GÉER: second oldest son of Sokna and Demba</p>
<p class="names">AMINATA (Ami): friend of Ramatoulaye</p>
<p class="names">BINTU: daughter fostered to Géer family</p>
<p class="names">CHEIKH CAAYA: husband of Cora</p>
<p class="names">CORA: friend of Sokna</p>
<p class="names">DEMBA GÉER: husband of Sokna Géer</p>
<p class="names">JIGEEN GÉER: oldest daughter of Sokna and Demba</p>
<p class="names">MODOU BAXA: father of Penda’s child</p>
<p class="names">MUSA MBACKE: Murid trader and suitor of Bintu</p>
<p class="names">PENDA: daughter of Cora</p>
<p class="names">RAMATOULAYE (Rama)GÉER: second oldest daughter of Sokna and Demba</p>
<p class="names">SOKNA GÉER: wife of Demba Géer</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// names_and_relationships.vue?63d3150e